import { PlatformAdminApi } from '../../../../../services/GrpcService';

export interface ILoyaltyBonusOperation {
  id?: string | null;
  createdAt?: string | null;
  type?: ILoyaltyBonusOperation.Type | null;
  typeText?: string | null;
  reason?: ILoyaltyBonusOperation.Reason | null;
  reasonText?: string | null;
  amount?: number | null;
  comment?: string | null;
  description?: string | null;
  author?: ILoyaltyBonusOperation.Author | null;
}

export namespace ILoyaltyBonusOperation {
  export enum Type {
    Accrual = 0,
    ChargeOff = 1,
    Block = 2,
  }

  export enum Reason {
    BonusPoints,
    WrongAccrual,
  }

  export interface Author extends PlatformAdminApi.LoyaltyBonusOperation.IAuthor {}
}
